const themeConfig = {
  mode: 'light',
  skin: 'default',
  disableRipple: true
}

export default themeConfig
